import { render, staticRenderFns } from "./QuestionsBeforeInvestingPanel.vue?vue&type=template&id=50e013fc&scoped=true&"
import script from "./QuestionsBeforeInvestingPanel.vue?vue&type=script&lang=js&"
export * from "./QuestionsBeforeInvestingPanel.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsBeforeInvestingPanel.vue?vue&type=style&index=0&id=50e013fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e013fc",
  null
  
)

export default component.exports